module.exports = __webpack_public_path__ + "static/edit-banner-show-on-page-location-10c406ce8a550d29b163159b227055fe.png";